// extracted by mini-css-extract-plugin
module.exports = {"container":"MainMenu_container__1PGYI"};